export default __webpack_public_path__ + "static/smedjan_prospekt_digital-d3ce4de2bea042a08e195bd7f425932d.pdf";